const api = function() {};

import axios from 'axios'
import http from '@/utils/http.js'

let BASE_HOST = process.env.BASE_HOST;

let url = BASE_HOST + 'Sq'; //需要登录的接口

let _url = BASE_HOST + 'Pq'; //不需要登录的接口

// 登录接口 
api.prototype.login = (data) => {
    return axios.post(BASE_HOST + 'Login', data)
}

// 注册接口 
api.prototype.register = (data) => {
    return axios.post(_url, data)
}

// 需要登录的接口 POST
api.prototype.requestAPI = (data) => {
    return http.post(url, data)
}

//不需要登录的接口 POST
api.prototype._requestAPI = (data) => {
    return http.post(_url, data)
}

// 需要登录的接口 GET
api.prototype.requestGetAPI = (data) => {
    return http.get(url, data)
}

//不需要登录的接口 GET
api.prototype._requestGetAPI = (data) => {
    return http.get(_url, data)
}

export default new api();


// WEBPACK FOOTER //
// ./src/service/api.js